module.exports = __webpack_public_path__ + "img/IN.9b60387d.png";